module.exports = require("dyna-count");